import { SynchronizedObject32xqzf15iiskd as SynchronizedObject } from '../../internal/Synchronized.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { copyOf2ng0t8oizk6it as copyOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SharedFlowImplm7e4zqeuk15m as SharedFlowImpl } from '../SharedFlow.mjs';
import { BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance } from '../../channels/BufferOverflow.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_EMPTY_RESUMES() {
  _init_properties_AbstractSharedFlow_kt__h2xygb();
  return EMPTY_RESUMES;
}
var EMPTY_RESUMES;
var AbstractSharedFlowClass;
function AbstractSharedFlow() {
  if (AbstractSharedFlowClass === VOID) {
    class $ extends SynchronizedObject() {
      constructor() {
        super();
        this.e1e_1 = null;
        this.f1e_1 = 0;
        this.g1e_1 = 0;
        this.h1e_1 = null;
      }
      a1f() {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        var tmp0_elvis_lhs = this.h1e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = new (SubscriptionCountStateFlow())(this.f1e_1);
          this.h1e_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      r1e() {
        var subscriptionCount;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        var curSlots = this.e1e_1;
        var tmp;
        if (curSlots == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.z1e(2);
          this.e1e_1 = this_0;
          tmp = this_0;
        } else {
          var tmp_0;
          if (this.f1e_1 >= curSlots.length) {
            // Inline function 'kotlin.also' call
            var this_1 = copyOf(curSlots, imul(2, curSlots.length));
            this.e1e_1 = this_1;
            tmp_0 = this_1;
          } else {
            tmp_0 = curSlots;
          }
          tmp = tmp_0;
        }
        var slots = tmp;
        var index = this.g1e_1;
        var slot;
        $l$loop: while (true) {
          var tmp0_elvis_lhs = slots[index];
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = this.y1e();
            slots[index] = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          slot = tmp_1;
          index = index + 1 | 0;
          if (index >= slots.length)
            index = 0;
          if ((slot instanceof AbstractSharedFlowSlot() ? slot : THROW_CCE()).c1f(this))
            break $l$loop;
        }
        this.g1e_1 = index;
        this.f1e_1 = this.f1e_1 + 1 | 0;
        subscriptionCount = this.h1e_1;
        var slot_0 = slot;
        if (subscriptionCount == null)
          null;
        else
          subscriptionCount.r1f(1);
        return slot_0;
      }
      v1e(slot) {
        var subscriptionCount;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        this.f1e_1 = this.f1e_1 - 1 | 0;
        subscriptionCount = this.h1e_1;
        if (this.f1e_1 === 0)
          this.g1e_1 = 0;
        var resumes = (slot instanceof AbstractSharedFlowSlot() ? slot : THROW_CCE()).e1f(this);
        var inductionVariable = 0;
        var last = resumes.length;
        while (inductionVariable < last) {
          var cont = resumes[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (cont == null)
            null;
          else {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
            cont.oc(tmp$ret$4);
          }
        }
        if (subscriptionCount == null)
          null;
        else
          subscriptionCount.r1f(-1);
      }
    }
    initMetadataForClass($, 'AbstractSharedFlow');
    AbstractSharedFlowClass = $;
  }
  return AbstractSharedFlowClass;
}
var AbstractSharedFlowSlotClass;
function AbstractSharedFlowSlot() {
  if (AbstractSharedFlowSlotClass === VOID) {
    class $ {}
    initMetadataForClass($, 'AbstractSharedFlowSlot');
    AbstractSharedFlowSlotClass = $;
  }
  return AbstractSharedFlowSlotClass;
}
var SubscriptionCountStateFlowClass;
function SubscriptionCountStateFlow() {
  if (SubscriptionCountStateFlowClass === VOID) {
    class $ extends SharedFlowImpl() {
      constructor(initialValue) {
        super(1, 2147483647, BufferOverflow_DROP_OLDEST_getInstance());
        this.w1e(initialValue);
      }
      n3() {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        return this.p1e();
      }
      r1f(delta) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        return this.w1e(this.p1e() + delta | 0);
      }
    }
    initMetadataForClass($, 'SubscriptionCountStateFlow', VOID, VOID, VOID, [1]);
    SubscriptionCountStateFlowClass = $;
  }
  return SubscriptionCountStateFlowClass;
}
var properties_initialized_AbstractSharedFlow_kt_2mpafr;
function _init_properties_AbstractSharedFlow_kt__h2xygb() {
  if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
    properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
    // Inline function 'kotlin.arrayOfNulls' call
    EMPTY_RESUMES = Array(0);
  }
}
//region block: exports
export {
  AbstractSharedFlowSlot as AbstractSharedFlowSlot2hcw2f06t03o0,
  AbstractSharedFlow as AbstractSharedFlow1jjql04jld86z,
  get_EMPTY_RESUMES as get_EMPTY_RESUMES1se3895plb5u1,
};
//endregion

//# sourceMappingURL=AbstractSharedFlow.mjs.map
